import React, { useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/forgot", { email });
    } catch {
      /* réponse générique : on n'indique jamais si le compte existe */
    } finally {
      setBusy(false);
      setSent(true);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-green p-4">
      <div className="nx-fade-up w-full max-w-sm">
        <div className="mb-6 flex flex-col items-center gap-3">
          <svg width="56" height="56" viewBox="0 0 100 100">
            <line x1="72" y1="22" x2="28" y2="78" stroke="#bcd2b2" strokeWidth="2.2" />
            <line x1="28" y1="22" x2="28" y2="78" stroke="#AADB4C" strokeWidth="6" strokeLinecap="round" />
            <line x1="72" y1="22" x2="72" y2="78" stroke="#AADB4C" strokeWidth="6" strokeLinecap="round" />
            <line x1="28" y1="22" x2="72" y2="78" stroke="#AADB4C" strokeWidth="6" strokeLinecap="round" />
            <circle cx="50" cy="50" r="9.7" fill="#AADB4C" />
            <circle cx="50" cy="50" r="3.3" fill="#00524A" />
          </svg>
          <h1 className="text-2xl font-extrabold tracking-wide text-white">NAXIUM ERP</h1>
        </div>

        {sent ? (
          <div data-testid="forgot-sent" className="nx-card space-y-4 p-6 text-center">
            <p className="text-sm text-ink">
              Si un compte actif correspond à cette adresse, un email contenant un lien de réinitialisation
              vient d'être envoyé. Ce lien est valable une heure.
            </p>
            <Link data-testid="forgot-login-link" to="/login" className="nx-btn-primary inline-flex w-full justify-center">
              Retour à la connexion
            </Link>
          </div>
        ) : (
          <form onSubmit={submit} className="nx-card space-y-4 p-6" data-testid="forgot-form">
            <div>
              <h2 className="text-lg font-bold text-green">Mot de passe oublié</h2>
              <p className="mt-1 text-sm text-muted">Saisissez votre adresse email : vous recevrez un lien pour définir un nouveau mot de passe.</p>
            </div>
            <div>
              <label className="nx-label">Email</label>
              <input
                data-testid="forgot-email-input"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="nx-input"
                placeholder="vous@naxium.net"
              />
            </div>
            <button data-testid="forgot-submit-btn" disabled={busy} className="nx-btn-primary w-full justify-center">
              {busy ? "Envoi…" : "Envoyer le lien"}
            </button>
            <Link data-testid="forgot-back-link" to="/login" className="block text-center text-sm text-green underline-offset-2 hover:underline">
              Retour à la connexion
            </Link>
          </form>
        )}
      </div>
    </div>
  );
}
